import {Banner} from "./MessageBanner";
import {Box, Button, Typography} from "@mui/material";
import palette from "../../theme/palette";
import {Icon} from "@iconify/react";
import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {toggleDispatchCancelChukker, toggleDispatchSaveChukker} from "../../store/reducers/display.reducer";

export const ChukkersEditedBanner = () => {

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const dispatchChukkerSave = () => {
        dispatch(toggleDispatchSaveChukker(true))
    }

    const dispatchCancelUpdate = () => {
        dispatch(toggleDispatchCancelChukker(true))
    }


    return <Banner bgColor={palette.light.warning.main}>
        <Box display={'flex'} flexDirection={{md: 'row', xs: 'column'}} justifyContent={"space-between"}
             alignItems={'center'} gap={2} width="100%">
            <Box display={'flex'} alignItems={'center'} flex={1} gap={1}>
                <Icon
                    width={22}
                    height={22}
                    style={{width: 22, height: 22, flexShrink: 0}}
                    icon='carbon:unsaved'></Icon>
                <Typography variant={'subtitle2'}>{t('chukkers:changedMessage')}</Typography>
            </Box>
            <Box display={'flex'} gap={1}>
                <Button onClick={dispatchCancelUpdate} >{t('button:cancel')}</Button>
                <Button onClick={dispatchChukkerSave} variant={'contained'} disableElevation>{t('button:save')}</Button>
            </Box>

        </Box>

    </Banner>
}